import styled from 'styled-components';

export const H1 = styled.h1.attrs({ className: 'cds-t-h1' })``;

export const H2 = styled.h2.attrs({ className: 'cds-t-h2' })``;

export const H3 = styled.h3.attrs({ className: 'cds-t-h3' })``;

export const H4 = styled.h4.attrs({ className: 'cds-t-h4' })``;

export const H5 = styled.h5.attrs({ className: 'cds-t-h5' })``;

export const H6 = styled.h6.attrs({ className: 'cds-t-h6' })``;
